import moment from "moment";
import { useFormContext } from "react-hook-form";
import { IParcelasCustasRequest } from "../../../../Interfaces/Geral/LancamentoCustas/LancamentoCustasInterface";
import { MoneyReaisFieldMask } from "../../../../Validations/InputMasks";

export function InserirValores() {
    const formLancamentoCusta = useFormContext<IParcelasCustasRequest>();
    const { register, formState } = formLancamentoCusta;
    return (
        <>
            <h3 className="mt-5">
                Insira o Valor e informações para o Lançamento de Custas:
            </h3>
            <div className="d-flex flex-wrap justify-content-between align-items-end mt-6">
                <div className="d-flex flex-wrap justify-content-center my-2 col-sm-6 col-lg-3">
                    <label className="text-center">Valor: </label>
                    <input
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.Valor && "is-invalid"
                        }`}
                        name="Valor"
                        onChange={MoneyReaisFieldMask}
                        ref={register({
                            required: true,
                            setValueAs: (v: string) =>
                                Number(MoneyReaisFieldMask.unMask(v)),
                        })}
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center my-2 col-sm-6 col-lg-3">
                    <label className="text-center">
                        Número da parcela (opcional):{" "}
                    </label>
                    <input
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.NUMEROPARCELA && "is-invalid"
                        }`}
                        name="NUMEROPARCELA"
                        type="number"
                        min={0}
                        ref={register()}
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center my-2 col-sm-6 col-lg-3">
                    <label className="text-center">Data Vencimento: </label>
                    <input
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.DtVencimento && "is-invalid"
                        }`}
                        name="DtVencimento"
                        type="Date"
                        defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                        ref={register({
                            required: true,
                        })}
                    />
                </div>
                <div className="d-flex flex-wrap justify-content-center my-2 col-sm-6 col-lg-3">
                    <label className="text-center">Data Reajuste:</label>
                    <input
                        className={`form-control placeholder-dark-50  ${
                            formState.errors.DtReajuste && "is-invalid"
                        }`}
                        type="Date"
                        defaultValue={moment(Date.now()).format("YYYY-MM-DD")}
                        name="DtReajuste"
                        ref={register({
                            required: true,
                        })}
                    />
                </div>
            </div>
        </>
    );
}
